export const MODAL_JUSTIFICATIVA = 'MODAL_JUSTIFICATIVA';
export const modalJustificativa = (modalJustificativa) => ({
  type: MODAL_JUSTIFICATIVA,
  payload: {
    modalJustificativa: modalJustificativa,
  },
});

export const MODAL_LAMINA = 'MODAL_LAMINA';
export const modalLamina = (modalLamina) => ({
  type: MODAL_LAMINA,
  payload: {
    modalLamina: modalLamina,
  },
});
export const ATUALIZAR_LISTAGEM_LAMINAS = 'ATUALIZAR_LISTAGEM_LAMINAS';
export const atualizarListagemLaminas = (listarLaminas) => ({
  type: ATUALIZAR_LISTAGEM_LAMINAS,
  payload: {
    listarLaminas: listarLaminas,
  },
});

export const CARREGAR_LAMINAS = 'CARREGAR_LAMINAS';
export const carregarLaminas = (carregarLaminas) => ({
  type: CARREGAR_LAMINAS,
  payload: {
    carregarLaminas: carregarLaminas,
  },
});

export const ALTERAR_TEXT_LAMINA = 'ALTERAR_TEXT_LAMINA';
export const alterarLaminaText = (laminaText) => ({
  type: ALTERAR_TEXT_LAMINA,
  payload: {
    laminaText: laminaText,
  },
});
export const ALTERAR_ID_LAMINA = 'ALTERAR_ID_LAMINA';
export const alterarLaminaId = (laminaId) => ({
  type: ALTERAR_ID_LAMINA,
  payload: {
    laminaId: laminaId,
  },
});
export const ALTERAR_EDICAO = 'ALTERAR_EDICAO';
export const alterarEdicao = (isEdicao) => ({
  type: ALTERAR_EDICAO,
  payload: {
    isEdicao: isEdicao,
  },
});
export const CARREGAR_EDICAO = 'CARREGAR_EDICAO';
export const carregarEdicao = (carregarEdicao) => ({
  type: CARREGAR_EDICAO,
  payload: {
    carregarEdicao: carregarEdicao,
  },
});
export const ALTERAR_TAB = 'ALTERAR_TAB';
export const alterarTab = (activeTab) => ({
  type: ALTERAR_TAB,
  payload: {
    activeTab: activeTab,
  },
});



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.action.js